module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: Duplicate Drone Model","page.description":"ทำการสร้าง Drone Model ใหม่โดยใช้ข้อมูลแบบรุ่น {name}","duplicate_model.success":"ทำการสร้าง Drone รุ่น {name} ในระบบเรียบร้อย","duplicate_model.submit.label":"เพิ่มรุ่นใหม่","duplicate_model.confirm.title":"ยืนยันการสร้าง Drone Model","duplicate_model.confirm.message":"คุณต้องการสร้าง Drone Model ใหม่?"}}')
  delete Component.options._Ctor
}
